// @ts-nocheck — duplicate message keys are intentional (last wins); file is data-only.
/* Reactify Langs

Translations Squence

01.Topbar
02. Offcanvas Menu
03. Breadcrumbs
*/

const messages = {
  // Top Navbar Translations
  "menu.search": "Rechercher....",
  "topbar.messages": "Messages",
  "topbar.mark-all": "Marquer tout",
  "topbar.view-all": "Tout voir",

  // Offcanvas Menu
  "menu.main": "Dasboards",
  "menu.dashboard": "Disposition principale",
  "topbar.mark-all": "Marquer tout",
  "topbar.view-all": "Tout voir",

  // Breadcrumbs
  "menu.default": "Par Défaut",
  "menu.layout": "Disposition Principale",
  "menu.app": "Accueil",
  "menu.adverts": "Annonces",
  "menu.saas-crm": "SaaS / CRM",
  "menu.analytics": "Analytique",
  "menu.ecommerce": "Admin e-commerce",
  "menu.finance": "Finance",
  "menu.industrial": "Industriel",
  "menu.ai-studio": "Studio IA",
  "menu.devops": "DevOps / SRE",
  "menu.subscription-plg": "Abonnement / PLG",
  "menu.hr-people": "RH / People",
  "menu.logistics": "Logistique",
  "menu.healthcare": "Santé",
  "menu.education": "Formation / LMS",
  "menu.real-estate": "Immobilier",
  "menu.security": "Sécurité / SOC",

  "suite.nav.overview": "Vue d’ensemble",
  "suite.col.actions": "Actions",
  "suite.col.id": "ID",
  "suite.col.title": "Titre",
  "suite.col.name": "Nom",
  "suite.col.status": "Statut",
  "suite.col.type": "Type",
  "suite.col.time": "Heure",
  "suite.col.subject": "Sujet",
  "suite.col.priority": "Priorité",
  "suite.col.assignee": "Assigné",
  "suite.col.tier": "Niveau",
  "suite.col.region": "Région",
  "suite.col.contacts": "Contacts",
  "suite.col.shortcut": "Raccourci",
  "suite.col.updated": "Mis à jour",
  "suite.col.author": "Auteur",
  "suite.col.views": "Vues",
  "suite.col.post": "Article",
  "suite.col.body": "Texte",
  "suite.col.folder": "Dossier",
  "suite.col.size": "Taille",
  "suite.col.resource": "Ressource",
  "suite.col.expires": "Expire",
  "suite.col.permissions": "Permissions",
  "suite.col.spend": "Dépense",
  "suite.col.roas": "ROAS",
  "suite.col.stage": "Étape",
  "suite.col.value": "Valeur",
  "suite.col.owner": "Propriétaire",
  "suite.col.email": "E-mail",
  "suite.col.schedule": "Planification",
  "suite.col.sku": "SKU",
  "suite.col.price": "Prix",
  "suite.col.stock": "Stock",
  "suite.col.customer": "Client",
  "suite.col.total": "Total",
  "suite.col.channel": "Canal",
  "suite.col.order": "Commande",
  "suite.col.reason": "Motif",
  "suite.col.amount": "Montant",
  "suite.col.client": "Client",
  "suite.col.due": "Échéance",
  "suite.col.invoice": "Facture",
  "suite.col.method": "Méthode",
  "suite.col.date": "Date",
  "suite.col.vendor": "Fournisseur",
  "suite.col.category": "Catégorie",
  "suite.col.period": "Période",
  "suite.col.department": "Service",
  "suite.col.planned": "Prévu",
  "suite.col.actual": "Réel",
  "suite.col.variance": "Écart",
  "suite.col.site": "Site",
  "suite.col.oee": "TRS",
  "suite.col.severity": "Gravité",
  "suite.col.message": "Message",
  "suite.col.asset": "Actif",
  "suite.col.env": "Environnement",
  "suite.col.budget": "Budget (USD)",
  "suite.col.used": "Utilisé (USD)",
  "suite.col.label": "Libellé",
  "suite.col.prefix": "Préfixe",
  "suite.col.created": "Créé",
  "suite.col.lastUsed": "Dernière utilisation",
  "suite.col.model": "Modèle",
  "suite.col.tokens": "Jetons",
  "suite.col.traffic": "Trafic %",
  "suite.col.latency": "Latence (ms)",
  "suite.col.company": "Entreprise",
  "suite.col.started": "Début",
  "suite.col.step": "Étape",
  "suite.col.score": "Score",
  "suite.col.adoption": "Adoption",
  "suite.col.target": "Cible",
  "suite.col.mrrLost": "MRR perdu",
  "suite.col.saved": "Sauvé",
  "suite.col.daysOpen": "Jours ouverts",
  "suite.col.employee": "Collaborateur",
  "suite.col.range": "Période",
  "suite.col.location": "Lieu",
  "suite.col.dept": "Service",
  "suite.col.lane": "Lane",
  "suite.col.carrier": "Transporteur",
  "suite.col.eta": "ETA",
  "suite.col.otd": "OTD %",
  "suite.col.volume": "Volume",
  "suite.col.code": "Code",
  "suite.col.util": "Utilisation %",
  "suite.col.throughput": "Débit",
  "suite.col.patient": "Patient",
  "suite.col.provider": "Soignant",
  "suite.col.payer": "Payeur",
  "suite.col.learners": "Apprenants",
  "suite.col.completion": "Complétion %",
  "suite.col.active": "Actif %",
  "suite.col.coursesActive": "Parcours actifs",
  "suite.col.address": "Adresse",
  "suite.col.dom": "Jours sur marché",
  "suite.col.source": "Source",
  "suite.col.interest": "Intérêt",
  "suite.col.property": "Bien",
  "suite.col.buyer": "Acquéreur",
  "suite.col.closeDate": "Date de clôture",
  "suite.col.cvss": "CVSS",
  "suite.col.sla": "SLA",
  "suite.col.evidence": "Preuve",
  "suite.col.actor": "Acteur",
  "suite.col.action": "Action",
  "suite.col.target": "Cible",
  "suite.col.compliant": "Conformité %",
  "suite.col.posts": "Articles",
  "suite.col.slug": "Slug",
  "suite.col.mrr": "MRR",
  "suite.col.health": "Santé",
  "suite.col.rotation": "Rotation",
  "suite.col.version": "Version",
  "suite.col.ago": "Quand",
  "suite.action.open": "Ouvrir",
  "suite.action.back": "Retour",
  "suite.action.save": "Enregistrer",
  "suite.state.error": "Erreur",
  "suite.state.empty": "Aucune ligne.",
  "suite.state.notfound": "Introuvable.",
  "suite.search.placeholder": "Filtrer…",
  "suite.main.notifications": "Notifications",
  "suite.main.search": "Recherche",
  "suite.main.shortcuts": "Raccourcis",
  "suite.main.search-results": "Résultats",
  "suite.main.shortcut-finance": "Vue finance",
  "suite.main.shortcut-tickets": "File tickets",
  "suite.main.shortcut-finance-sub": "Factures, paiements, budgets",
  "suite.main.shortcut-tickets-sub": "File, SLA, macros",
  "suite.ticketing.tickets": "File tickets",
  "suite.ticketing.customers": "Organisations",
  "suite.ticketing.macros": "Macros",
  "suite.ticketing.sla": "Paramètres SLA",
  "suite.ticketing.ticket-detail": "Ticket",
  "suite.ticketing.thread": "Conversation",
  "suite.ticketing.sidebar": "Actions",
  "suite.ticketing.sidebar-body": "Branchez macros, assignation et notes internes via votre API.",
  "suite.ticketing.reply": "Répondre",
  "suite.ticketing.insert-macro": "Insérer macro",
  "suite.ticketing.sla-first": "Première réponse (min)",
  "suite.ticketing.sla-resolution": "Résolution cible (min)",
  "suite.ticketing.sla-hours": "Heures ouvrées",
  "suite.ticketing.customer-detail": "Organisation",
  "suite.ticketing.sla-badge": "SLA à risque",
  "suite.ticketing.queue-empty": "Aucun ticket ne correspond à cette vue.",
  "suite.ticketing.summary-total": "tickets",
  "suite.ticketing.bulk-assign-demo": "Assignation groupée (démo)",
  "suite.ticketing.macro-preview-panel": "Aperçu macro rapide",
  "suite.ticketing.macro-uses": "Utilisations (30j)",
  "suite.ticketing.all-macros": "Toutes les macros",
  "suite.blogging.posts": "Articles",
  "suite.blogging.categories": "Catégories",
  "suite.blogging.media": "Médias",
  "suite.blogging.comments": "Commentaires",
  "suite.blogging.post-detail": "Article",
  "suite.storage.files": "Fichiers",
  "suite.storage.shares": "Liens partagés",
  "suite.storage.settings": "Paramètres stockage",
  "suite.storage.file-detail": "Fichier",
  "suite.storage.quota": "Quota (Go)",
  "suite.storage.retention": "Rétention (jours)",
  "suite.adverts.campaigns": "Campagnes",
  "suite.adverts.reports": "Performance",
  "suite.adverts.billing": "Facturation",
  "suite.adverts.campaign-detail": "Campagne",
  "suite.crm.deals": "Affaires",
  "suite.crm.accounts": "Comptes",
  "suite.crm.contacts": "Contacts",
  "suite.crm.activities": "Activités",
  "suite.crm.deal-detail": "Affaire",
  "suite.crm.account-detail": "Compte",
  "suite.analytics.reports": "Rapports",
  "suite.analytics.builder": "Concepteur",
  "suite.analytics.exports": "Exports",
  "suite.analytics.report-detail": "Rapport",
  "suite.analytics.field-dataset": "Jeu de données",
  "suite.analytics.field-dimensions": "Dimensions",
  "suite.analytics.field-metrics": "Mesures",
  "suite.ecom.products": "Produits",
  "suite.ecom.orders": "Commandes",
  "suite.ecom.customers": "Clients",
  "suite.ecom.returns": "Retours",
  "suite.ecom.product-detail": "Produit",
  "suite.ecom.order-detail": "Commande",
  "suite.ecom.customer-detail": "Client",
  "suite.finance.invoices": "Factures",
  "suite.finance.payments": "Paiements",
  "suite.finance.expenses": "Dépenses",
  "suite.finance.budgets": "Budgets",
  "suite.finance.invoice-detail": "Facture",
  "suite.industrial.assets": "Actifs",
  "suite.industrial.alerts": "Alertes",
  "suite.industrial.workorders": "Ordres de travail",
  "suite.industrial.asset-detail": "Actif",
  "suite.industrial.workorder-detail": "Ordre de travail",
  "suite.aistudio.projects": "Projets",
  "suite.aistudio.keys": "Clés API",
  "suite.aistudio.logs": "Journaux",
  "suite.aistudio.experiments": "Expérimentations",
  "suite.aistudio.settings": "Limites",
  "suite.aistudio.project-detail": "Projet",
  "suite.aistudio.rpm-limit": "Limite req/min",
  "suite.aistudio.monthly-budget": "Budget mensuel (USD)",
  "suite.devops.services": "Services",
  "suite.devops.incidents": "Incidents",
  "suite.devops.deploys": "Déploiements",
  "suite.devops.runbooks": "Runbooks",
  "suite.devops.oncall": "Astreinte",
  "suite.devops.service-detail": "Service",
  "suite.devops.incident-detail": "Incident",
  "suite.devops.deploys-hint": "Développez chaque ligne pour les commits et un diff factice.",
  "suite.devops.diff-placeholder": "Chemins modifiés (stub)",
  "suite.plg.accounts": "Comptes",
  "suite.plg.trials": "Essais",
  "suite.plg.features": "Adoption fonctionnalités",
  "suite.plg.churn": "Churn",
  "suite.plg.account-detail": "Compte",
  "suite.hr.employees": "Collaborateurs",
  "suite.hr.requisitions": "Postes ouverts",
  "suite.hr.timeoff": "Congés",
  "suite.hr.settings": "Paramètres RH",
  "suite.hr.employee-detail": "Collaborateur",
  "suite.hr.requisition-detail": "Poste",
  "suite.hr.default-location": "Lieu par défaut",
  "suite.hr.work-week": "Semaine de travail",
  "suite.logistics.shipments": "Expéditions",
  "suite.logistics.carriers": "Transporteurs",
  "suite.logistics.warehouses": "Entrepôts",
  "suite.logistics.exceptions": "Exceptions",
  "suite.logistics.shipment-detail": "Expédition",
  "suite.health.appointments": "Rendez-vous",
  "suite.health.claims": "Réclamations",
  "suite.health.providers": "Soignants",
  "suite.health.appointment-detail": "Rendez-vous",
  "suite.health.claim-detail": "Réclamation",
  "suite.edu.courses": "Parcours",
  "suite.edu.cohorts": "Cohortes",
  "suite.edu.learners": "Apprenants",
  "suite.edu.course-detail": "Parcours",
  "suite.edu.cohort-detail": "Cohorte",
  "suite.edu.learner-detail": "Apprenant",
  "suite.re.listings": "Annonces",
  "suite.re.leads": "Leads",
  "suite.re.transactions": "Transactions",
  "suite.re.listing-detail": "Annonce",
  "suite.sec.vulns": "Vulnérabilités",
  "suite.sec.policies": "Politiques",
  "suite.sec.audit": "Journal d’audit",
  "suite.sec.vuln-detail": "Finding",

  "suite.mock.pagination-range": "Affichage",
  "suite.mock.pagination-of": "sur",
  "suite.mock.pagination-label": "Pagination démo",
  "suite.mock.page-size": "Lignes",
  "suite.overview.quick-links": "Accès rapide",

  "hr.hero.headline": "Vue RH opérationnelle",
  "hr.hero.sub": "Recrutement, engagement et tâches conformité — données de démo.",
  "hr.hero.open-ats": "Ouvrir l’ATS",
  "hr.section.news": "Annonces RH",
  "hr.kpi.headcount": "Effectif",
  "hr.kpi.open-roles": "Postes ouverts",
  "hr.kpi.tth": "Délai moyen de recrutement",
  "hr.kpi.turnover": "Turnover annualisé",
  "hr.kpi.engagement": "Indice d’engagement",
  "hr.kpi.reviews": "Entretiens à faire",
  "hr.kpi.out": "Absents aujourd’hui",
  "hr.chart.funnel": "Entonnoir de recrutement",
  "hr.chart.tth": "Tendance délai de recrutement",
  "hr.chart.dept": "Effectif vs postes ouverts",
  "hr.chart.diversity": "Représentation (auto-déclarée)",
  "hr.chart.pto": "Utilisation des congés par équipe",
  "hr.section.org": "Couverture dirigeants",
  "hr.org.reports": "collaborateurs",
  "hr.table.roles": "Postes ouverts prioritaires",
  "hr.section.reviews": "Entretiens annuels",
  "hr.col.title": "Poste",
  "hr.col.dept": "Service",
  "hr.col.location": "Lieu",
  "hr.col.stage": "Étape",
  "hr.col.days": "Jours ouverts",
  "hr.col.name": "Collaborateur",
  "hr.col.role": "Intitulé",
  "hr.col.due": "Échéance",
  "hr.col.type": "Cycle",

  "logistics.hero.title": "Tour de contrôle réseau",
  "logistics.hero.sub": "Santé des lanes, transporteurs et exceptions — données illustratives.",
  "logistics.hero.dispatch": "Tableau dispatch",
  "logistics.hero.export": "Export CSV",
  "logistics.section.ops-alerts": "Alertes ops",
  "logistics.kpi.routes": "Routes actives",
  "logistics.kpi.ontime": "Livraison à l’heure",
  "logistics.kpi.exceptions": "Exceptions ouvertes",
  "logistics.kpi.transit": "Transit moyen",
  "logistics.kpi.wh-util": "Utilisation entrepôt",
  "logistics.kpi.cpp": "Coût / colis",
  "logistics.map.title": "Charge par hub (schéma)",
  "logistics.map.caption": "Volume relatif par hub — pas une carte live.",
  "logistics.map.legend": "Pastille = code aéroport · chiffre = indice de charge (démo)",
  "logistics.chart.sla": "% à l’heure vs cible",
  "logistics.chart.carrier-otd": "OTD par transporteur",
  "logistics.chart.carrier-vol": "Volume par transporteur",
  "logistics.chart.warehouse": "Palettes entrée / sortie",
  "logistics.table.exceptions": "File d’exceptions",
  "logistics.table.fleet": "Flotte (instantané)",
  "logistics.col.id": "ID",
  "logistics.col.type": "Type",
  "logistics.col.lane": "Lane",
  "logistics.col.severity": "Gravité",
  "logistics.col.age": "Âge",
  "logistics.col.truck": "Actif",
  "logistics.col.driver": "Chauffeur",
  "logistics.col.origin": "Origine",
  "logistics.col.dest": "Destination",
  "logistics.col.eta": "ETA",
  "logistics.col.status": "Statut",

  "health.disclaimer.title": "Interface de démo uniquement.",
  "health.disclaimer.body": "Données fictives à des fins de maquette. Pas destiné aux données de santé protégées ; ne garantit pas la conformité HIPAA.",
  "health.kpi.appts": "RDV du jour",
  "health.kpi.checkin": "Enregistrés",
  "health.kpi.wait": "Attente moy.",
  "health.kpi.noshow": "Taux de lapins",
  "health.kpi.providers": "Soignants en service",
  "health.kpi.csat": "Satisfaction",
  "health.kpi.revenue": "CA jour estimé",
  "health.table.schedule": "Planning du jour",
  "health.table.queue": "Salle d’attente",
  "health.chart.providers": "Utilisation des praticiens",
  "health.chart.dept-wait": "Attente moy. par service",
  "health.chart.billing": "Mix payeurs (démo)",
  "health.chart.noshow": "Tendance lapins",
  "health.section.patients-day": "Patients vus vs utilisation",
  "health.table.claims": "File des réclamations",
  "health.col.time": "Heure",
  "health.col.patient": "Patient",
  "health.col.provider": "Praticien",
  "health.col.room": "Salle",
  "health.col.type": "Type de visite",
  "health.col.status": "Statut",
  "health.col.ticket": "Ticket",
  "health.col.wait": "Attente",
  "health.col.priority": "Priorité",
  "health.col.dept": "Service",
  "health.col.claim": "Réclamation",
  "health.col.payer": "Payeur",
  "health.col.amount": "Montant",
  "health.col.age": "Âge",
  "health.col.patients": "Patients",
  "health.col.util": "Utilisation",

  "edu.hero.title": "Hub formation & certif.",
  "edu.hero.sub": "Cohortes, santé des parcours et impact formateurs — démo.",
  "edu.hero.cohort": "Nouvelle cohorte",
  "edu.section.news": "Infos L&D",
  "edu.kpi.learners": "Apprenants actifs",
  "edu.kpi.courses": "Parcours publiés",
  "edu.kpi.completion": "Taux de complétion",
  "edu.kpi.certs": "Certificats (30j)",
  "edu.kpi.score": "Score moyen",
  "edu.kpi.nps": "NPS apprenants",
  "edu.kpi.revenue": "Chiffre d’affaires",
  "edu.chart.enrollment": "Inscriptions vs complétions",
  "edu.chart.funnel": "Entonnoir de complétion",
  "edu.chart.activity": "Heures d’apprentissage / jour",
  "edu.chart.segments": "Segments d’apprenants",
  "edu.section.cohorts": "Cohortes actives",
  "edu.cohort.learners": "apprenants",
  "edu.cohort.active": "actifs cette semaine",
  "edu.table.courses": "Meilleurs parcours",
  "edu.table.instructors": "Classement formateurs",
  "edu.col.course": "Parcours",
  "edu.col.enrolled": "Inscrits",
  "edu.col.completion": "Complétion",
  "edu.col.rating": "Note",
  "edu.col.instructor": "Formateur",
  "edu.col.courses": "Parcours",

  "re.hero.title": "Pipeline annonces & mandats",
  "re.hero.new-listing": "Nouvelle annonce",
  "re.hero.tour": "Planifier visite",
  "re.section.hot": "Annonces chaudes / nouvelles",
  "re.kpi.listings": "Annonces actives",
  "re.kpi.new": "Nouvelles (7j)",
  "re.kpi.dom": "Jours moy. sur marché",
  "re.kpi.pipeline": "Valeur pipeline",
  "re.kpi.leads": "Leads (semaine)",
  "re.kpi.viewings": "Visites (semaine)",
  "re.kpi.cvr": "conv. lead→visite",
  "re.chart.pipeline-count": "Annonces par étape",
  "re.chart.pipeline-value": "Valeur ($M) par étape",
  "re.chart.leads": "Leads par source",
  "re.chart.dom": "Tendance jours sur marché",
  "re.chart.price": "Stock par tranche de prix",
  "re.section.viewings": "Visites à venir",
  "re.table.agents": "Perf. agents (90j)",
  "re.col.agent": "Agent",
  "re.col.listings": "Annonces",
  "re.col.volume": "Volume",
  "re.col.deals": "Transactions",
  "re.col.when": "Quand",
  "re.col.property": "Bien",
  "re.col.type": "Type",

  "sec.hero.title": "Vue posture sécurité",
  "sec.hero.sub": "Vulnérabilités, abus d’auth et contrôles — télémétrie de démo.",
  "sec.hero.scan": "Lancer évaluation",
  "sec.hero.report": "Rapport dirigeants",
  "sec.section.threat": "Veille menaces",
  "sec.kpi.score": "Score de posture",
  "sec.kpi.score-delta": "vs mois dernier",
  "sec.kpi.vulns": "Findings ouverts",
  "sec.kpi.critical": "critiques",
  "sec.kpi.patch": "Délai moyen de patch",
  "sec.kpi.policies": "Conformité politiques",
  "sec.kpi.logins": "logins échoués (24h)",
  "sec.kpi.incidents": "incidents ouverts",
  "sec.chart.vuln-stack": "Par sévérité — ouverts vs corrigés",
  "sec.chart.vuln-trend": "Ouverts vs clos (hebdo)",
  "sec.chart.regions": "Logins échoués & blocages par région",
  "sec.section.policies": "Contrôles",
  "sec.table.vulns": "File CVE prioritaire",
  "sec.table.audit": "Flux audit sécurité",
  "sec.col.cve": "CVE",
  "sec.col.asset": "Actif",
  "sec.col.cvss": "CVSS",
  "sec.col.sla": "SLA",
  "sec.col.age": "Âge",
  "sec.col.time": "Heure",
  "sec.col.actor": "Acteur",
  "sec.col.action": "Action",
  "sec.col.target": "Cible",

  "ai-studio.hero.budget": "Budget mensuel utilisé",
  "ai-studio.hero.adjust": "Limites",
  "ai-studio.hero.rpm": "Requêtes par minute",
  "ai-studio.section.alerts": "Alertes récentes",
  "ai-studio.kpi.tokens": "Jetons (24h)",
  "ai-studio.kpi.latency": "Latence moy.",
  "ai-studio.kpi.errors": "Taux d’erreur",
  "ai-studio.kpi.keys": "Clés API actives",
  "ai-studio.chart.models": "Requêtes par modèle",
  "ai-studio.chart.cost": "Coût et volume de jetons",
  "ai-studio.chart.latency": "Latence par heure (p50)",
  "ai-studio.section.keys": "État des clés API",
  "ai-studio.table.experiments": "Expérimentations",
  "ai-studio.table.prompts": "Invites récentes (échantillon)",
  "ai-studio.col.experiment": "Expérimentation",
  "ai-studio.col.model": "Modèle",
  "ai-studio.col.status": "Statut",
  "ai-studio.col.traffic": "Trafic %",
  "ai-studio.col.id": "Requête",
  "ai-studio.col.preview": "Aperçu",
  "ai-studio.col.tokens": "Jetons",

  "devops.slo.target": "Objectif SLO",
  "devops.slo.actual": "Dispo. glissante",
  "devops.slo.budget": "Budget d’erreur restant",
  "devops.slo.burn": "Taux de burn (30j)",
  "devops.chart.errors": "Erreurs et déploiements",
  "devops.section.oncall": "Astreinte",
  "devops.oncall.primary": "Principal",
  "devops.oncall.secondary": "Secondaire",
  "devops.section.services": "État des services",
  "devops.section.deploys": "Déploiements",
  "devops.section.incidents": "Incidents",
  "devops.section.audit": "Journal des changements",
  "devops.col.title": "Titre",
  "devops.col.severity": "Gravité",
  "devops.col.state": "État",
  "devops.col.time": "Heure",
  "devops.col.who": "Acteur",
  "devops.col.what": "Changement",

  "plg.hero.nps": "NPS (glissant)",
  "plg.hero.survey": "Détails",
  "plg.hero.trials": "Essais actifs",
  "plg.hero.activation": "Activation à 7j",
  "plg.kpi.mrr": "MRR",
  "plg.kpi.arr": "ARR",
  "plg.kpi.churn": "Churn logos",
  "plg.kpi.expansion": "MRR d’expansion",
  "plg.chart.funnel": "Entonnoir d’essai self-serve",
  "plg.chart.growth": "MRR nouveau vs churn",
  "plg.chart.features": "Adoption des fonctionnalités",
  "plg.chart.csat": "Répartition CSAT",
  "plg.section.milestones": "Jalons croissance",
  "plg.table.accounts": "Comptes stratégiques",
  "plg.col.account": "Compte",
  "plg.col.plan": "Offre",
  "plg.col.mrr": "MRR",
  "plg.col.health": "Santé",
  "plg.col.stage": "Étape",

  "saas-crm.col.deal": "Affaire",
  "saas-crm.col.company": "Entreprise",
  "saas-crm.col.owner": "Propriétaire",
  "saas-crm.col.stage": "Étape",
  "saas-crm.col.value": "Valeur",
  "saas-crm.col.close": "Date de clôture",
  "saas-crm.col.health": "Santé",
  "saas-crm.col.account": "Compte",
  "saas-crm.col.tier": "Niveau",
  "saas-crm.col.seats": "Sièges",
  "saas-crm.kpi.mrr": "MRR",
  "saas-crm.kpi.arr": "ARR",
  "saas-crm.kpi.churn": "Attrition",
  "saas-crm.kpi.logo": "Expansion",
  "saas-crm.kpi.accounts": "Comptes actifs",
  "saas-crm.kpi.trials": "Essais actifs",
  "saas-crm.kpi.pipeline-value": "Valeur du pipeline",
  "saas-crm.kpi.won-deals": "Gagnées (étape)",
  "saas-crm.kpi.quick-actions": "Actions rapides",
  "saas-crm.action.new-deal": "Nouvelle affaire",
  "saas-crm.chart.mrr-trend": "MRR et nouveaux logos",
  "saas-crm.chart.plan-mix": "Mix des plans",
  "saas-crm.chart.pipeline": "Pipeline par étape",
  "saas-crm.section.accounts": "Santé des comptes",
  "saas-crm.section.tasks": "Tâches à échéance",
  "saas-crm.section.activity": "Activité du jour",
  "saas-crm.table.deals": "Opportunités ouvertes",

  "analytics.realtime.active": "Actifs maintenant",
  "analytics.realtime.live": "Vue live",
  "analytics.realtime.events": "Événements / min",
  "analytics.kpi.sessions": "Sessions",
  "analytics.kpi.users": "Utilisateurs",
  "analytics.kpi.bounce": "Taux de rebond",
  "analytics.kpi.session-time": "Durée moy. session",
  "analytics.kpi.conversions": "Conversions",
  "analytics.kpi.pageviews": "Pages vues",
  "analytics.kpi.funnel-start": "Entonnoir — haut",
  "analytics.kpi.funnel-paid": "Entonnoir — payant",
  "analytics.chart.funnel": "Entonnoir d’acquisition",
  "analytics.chart.channels": "Sessions par canal",
  "analytics.chart.trend": "Tendance sessions et événements",
  "analytics.chart.devices": "Répartition appareils",
  "analytics.section.retention": "Rétention par cohorte",
  "analytics.section.goals": "Objectifs vs cible",
  "analytics.table.pages": "Pages populaires",
  "analytics.table.events": "Événements populaires",
  "analytics.section.live-stream": "Flux d’événements live",
  "analytics.col.path": "Chemin",
  "analytics.col.views": "Vues",
  "analytics.col.exit": "Taux de sortie",
  "analytics.col.event": "Événement",
  "analytics.col.count": "Nombre",
  "analytics.col.time": "Heure",
  "analytics.col.detail": "Détail",

  "ecom.toolbar.new-order": "Nouvelle commande",
  "ecom.toolbar.export": "Exporter",
  "ecom.toolbar.sync": "Sync canaux",
  "ecom.kpi.revenue": "Chiffre d’affaires",
  "ecom.kpi.orders": "Commandes",
  "ecom.kpi.aov": "Panier moyen",
  "ecom.kpi.returns": "Taux de retour",
  "ecom.kpi.abandon": "Abandon panier",
  "ecom.kpi.cvr": "Taux de conversion",
  "ecom.kpi.shipping": "Livraison à l’heure",
  "ecom.kpi.skus-active": "SKU suivis",
  "ecom.chart.sales-week": "Commandes et CA (semaine)",
  "ecom.chart.order-status": "Commandes par statut",
  "ecom.chart.segments": "Clients par segment",
  "ecom.section.inventory": "Alertes stock",
  "ecom.section.top-skus": "Top SKU",
  "ecom.section.shipments": "Expéditions en cours",
  "ecom.label.eta": "Livraison estimée",
  "ecom.table.orders": "Commandes récentes",
  "ecom.section.refunds": "Remboursements récents",
  "ecom.col.order": "Commande",
  "ecom.col.customer": "Client",
  "ecom.col.items": "Articles",
  "ecom.col.total": "Total",
  "ecom.col.status": "Statut",
  "ecom.col.channel": "Canal",
  "ecom.col.date": "Date",
  "ecom.col.sku": "SKU",
  "ecom.col.product": "Produit",
  "ecom.col.on-hand": "Stock",
  "ecom.col.reorder": "Seuil réappro",
  "ecom.col.severity": "Gravité",
  "ecom.col.sold": "Vendus",
  "ecom.col.stock": "Stock",

  "finance.toolbar.close-period": "Clôturer la période",
  "finance.toolbar.reports": "Rapports financiers",
  "finance.kpi.cash": "Trésorerie",
  "finance.kpi.runway": "Autonomie",
  "finance.kpi.months": "mois",
  "finance.kpi.burn": "Burn mensuel",
  "finance.kpi.revenue-ytd": "CA YTD",
  "finance.kpi.ebitda": "EBITDA",
  "finance.kpi.ar": "Créances clients",
  "finance.kpi.ap": "Dettes fournisseurs",
  "finance.kpi.net-income": "Résultat net (T)",
  "finance.section.pl": "Aperçu P&L",
  "finance.pl.revenue": "Chiffre d’affaires",
  "finance.pl.cogs": "Coût des ventes",
  "finance.pl.opex": "Charges d’exploitation",
  "finance.pl.other": "Autres",
  "finance.pl.net": "Résultat net",
  "finance.chart.cashflow": "Flux de trésorerie",
  "finance.chart.budget": "Budget vs réel",
  "finance.chart.expenses": "Mix des dépenses",
  "finance.section.aging": "Aging créances",
  "finance.table.invoices": "Factures",
  "finance.chart.forecast": "Prévision CA & charges",
  "finance.legend.budget": "Budget",
  "finance.legend.actual": "Réel",
  "finance.legend.revenue": "CA",
  "finance.legend.expenses": "Charges",
  "finance.col.invoice": "Facture",
  "finance.col.customer": "Client",
  "finance.col.amount": "Montant",
  "finance.col.due": "Échéance",
  "finance.col.status": "Statut",

  "industrial.toolbar.ack-alarms": "Acquitter alarmes",
  "industrial.toolbar.shift-report": "Rapport d’équipe",
  "industrial.badge.active-alarms": "alarmes actives",
  "industrial.kpi.oee": "OEE site",
  "industrial.kpi.throughput": "Débit (unités)",
  "industrial.kpi.downtime": "Arrêts",
  "industrial.kpi.quality": "Qualité premier passage",
  "industrial.kpi.energy": "Énergie (jour)",
  "industrial.kpi.work-orders": "OT ouverts",
  "industrial.kpi.lines": "Lignes de prod.",
  "industrial.kpi.safety-days": "Jours sans LTI",
  "industrial.chart.output": "Production vs cible",
  "industrial.chart.downtime": "Causes d’arrêt",
  "industrial.section.lines": "État des lignes",
  "industrial.label.output": "Production",
  "industrial.chart.energy": "Consommation énergie",
  "industrial.chart.shifts": "Performance par équipe",
  "industrial.legend.planned": "Planifié",
  "industrial.legend.actual": "Réel",
  "industrial.section.alarms": "Alarmes actives",
  "industrial.table.maintenance": "File maintenance",
  "industrial.section.safety": "Journal sécurité",
  "industrial.col.wo": "Ordre de travail",
  "industrial.col.asset": "Équipement",
  "industrial.col.type": "Type",
  "industrial.col.due": "Échéance",
  "industrial.col.priority": "Priorité",
  "industrial.col.date": "Date",
  "industrial.col.area": "Zone",
  "industrial.col.status": "Statut",

  // Main Dashboard
  "main.weekly-sales": "Ventes hebdomadaires",
  "main.monthly-visits": "Vistances mensuelles",
  "main.items-for-sale": "Articles à vendre",
  "main.users": "Nombre total d'utilisateurs",
  "main.sales": "Chiffre d'affaires total",
  "main.statistics": "Statistiques",
  "main.traffic": "Trafic",
  "main.conversion": "Conversions",
  "main.bounce-rate": "Taux de rebond",
  "main.income": "Revenu",
  "main.order-status": "Statut de la commande",
  "main.product-categories": "Catégories de produits",
  "main.tasks": "Tâches",
  "main.team-messages": "Messages d'équipe",
  "menu.team-message": "Conversation",
  "team-message.title": "Conversation d'équipe",
  "team-message.subtitle": "Relisez le fil et envoyez une réponse.",
  "team-message.back-dashboard": "Retour au tableau de bord",
  "team-message.thread": "Fil de discussion",
  "team-message.last-activity": "Dernière activité",
  "team-message.you": "Vous",
  "team-message.reply-label": "Votre réponse",
  "team-message.reply-placeholder": "Écrire un message…",
  "team-message.send": "Envoyer",
  "team-message.send-hint": "Astuce : Ctrl+Entrée (⌘+Entrée sur Mac) pour envoyer.",
  "team-message.not-found-title": "Conversation introuvable",
  "team-message.not-found-body": "Ce contact ou ce fil n'existe pas. Revenez au tableau de bord et choisissez un message dans la liste.",
  "main.total-online": "Total en ligne",
  "main.total-offline": "Total hors ligne",
  "main.popular-items": "Articles populaires",
  "main.recent-activities": "Activités récentes",
  "main.customers-status": "Statut des clients",
  "main.todays": "Aujourd'hui",
  "main.weekly": "Hebdomadaire",
  "main.monthly": "Monthly",
  "main.yearly": "Mensuel",
  "main.sales-progress": "Progression des ventes",
  "main.sales-goal": "Objectif de vente",
  "main.weather-forecast": "Objectif de vente",
  "main.city-name": "Nom de la ville",
  "main.country-name": "Nom du pays",
  "main.last-year-income": "Revenu de l'année dernière",
  "main.get-weather-update": "Obtenir la mise à jour météo",
  "main.realtime-weather": "Météo en temps réel",
  "main.last-year-sales-report": "Rapport des ventes de l'an dernier",

  // Ticketing Layout
  "main.ticketing": "Billetterie",
  "menu.ticketing": "Billetterie",
  "ticketing.products": "Produits",
  "ticketing.tickets": "Billets de concert",
  "ticketing.users": "Utilisateurs",
  "ticketing.settings": "Réglages",
  "ticketing.monthly-sales": "Monthly Sales",
  "ticketing.income": "Ventes mensuelles",
  "ticketing.taxes": "Impôts et taxes",
  "ticketing.todays-sales": "Ventes d'aujourd'hui",
  "ticketing.weekly-tickets": "Billets hebdomadaires",
  "ticketing.weekly-tickets-progress": "Billets Hebdomadaires Progression",
  "ticketing.by-date": "Billets par date",
  "ticketing.overdue": "En retard",
  "ticketing.todays": "Aujourd'hui",
  "ticketing.tomorrow": "Demain, c'est l'anniversaire",
  "ticketing.this-week": "Cette semaine",
  "ticketing.this-month": "Ce mois-ci",
  "ticketing.close-tickets": "Billets fermés",
  "ticketing.by-importance": "Billets par importance",
  "ticketing.high-importance": "Élevée",
  "ticketing.medium": "Moyen",
  "ticketing.low": "Faible",
  "ticketing.replied": "Répondu",
  "ticketing.transfered": "Transféré",
  "ticketing.on-hold": "En attente",
  "ticketing.need-reply": "En attente d'une réponse",
  "ticketing.recent-tickets": "Billets récents",
  "ticketing.backup-completed": "Billets récents",
  "ticketing.servers-running": "Tous les serveurs en cours d'exécution",
  "ticketing.backup-failed": "Échec de la sauvegarde",
  "ticketing.files-transferred": "Fichiers transférés",
  "ticketing.latest-updates": "Dernières mises à jour",

  // Blogging

  "menu.blogging": "Blogging",
  "blogging.monthly-visits": "Visites mensuelles",
  "blogging.subscribers": "Abonnés",
  "blogging.comments": "Commentaires",
  "blogging.approved": "Approved",
  "blogging.pending": "Approuvé",
  "blogging.spam": "Spam",
  "blogging.posts": "Messages",
  "blogging.categories": "Catégories",
  "blogging.pages": "Pages",
  "blogging.tags": "Étiquettes",
  "blogging.twitter": "Twitter",
  "blogging.facebook": "Facebook",
  "blogging.pinterest": "Pinterest",
  "blogging.rss": "RSS",
  "blogging.email": "Courriel",
  "blogging.traffic-source": "Source de trafic",
  "blogging.recent-comments": "Commentaires récents",
  "blogging.edit": "Modifier",
  "blogging.delete": "Supprimer",
  "blogging.posted": "Posté le",
  "blogging.popular-posts": "Messages populaires",
  "blogging.views": "Vues",
  "blogging.comments": "Commentaires",

  // Storage
  "storage.menu": "Stockage",
  "menu.storage": "Stockage",
  "storage.files": "Fichiers",
  "storage.zipped": "Zippé",
  "storage.photos": "Photos",
  "storage.videos": "Vidéos",
  "storage.temperature": "Température CPU",
  "storage.bandwidth": "Utilisation de la bande passante",
  "storage.max-value": "Valeur Max",
  "storage.min-value": "Valeur minimale",
  "storage.total-storage": "Stockage total - PB",
  "storage.used-storage": "Stockage d'occasion - PB",
  "storage.todays-tip": "Conseil du jour",
  "storage.tip-desc": "Vendre une expérience, pas un objet.",
  "storage.social-interactions": "Interactions sociales",
  "storage.target-more": "Cible 9 500 ou plus",
  "storage.events": "Événements",
  "storage.views": "Vues",
  "storage.web-metric": "Principales mesures sur le Web",
  "storage.target-or-less": "Cible : 200:1 ou moins",
  "storage.average-ratio":
    "170:1 Nombre de visiteurs par rapport au nombre de leaders",
  "storage.visitors": "Visiteurs",
  "storage.leads": "Plombs",
  "storage.site-events": "Événements sur le site",
  "storage.uploads-metrics": "Métriques des téléchargements",
  "storage.uploads-target": "5:1 ou moins",
  "storage.making-uploads": "Réaliser des téléchargements",
  "storage.recent": "Récentes",
  "storage.per-minute": "Par minute",
  "storage.load": "Charge",

  // Adverts

  "adverts.todays-so-far": "Aujourd'hui, c'est trop tard.",
  "adverts.yesterday": "Hier",
  "adverts.last-week-same-day": "VS. même jour la semaine dernière",
  "adverts.last-week": "La semaine dernière",
  "adverts.last-seven-days": "VS. 7 derniers jourss",
  "adverts.balance": "Balance",
  "adverts.last-payment": "Dernier paiement",

  // Shortcodes Menu

  "menu.shortcodes": "Codes courts",
  "menu.buttons": "Boutons",
  "menu.social": "Boutons sociaux",
  "menu.badges": "Badges",
  "menu.tabs": "Onglets",
  "menu.progress": "Barres de progression",
  "menu.timeline": "Calendrier",
  "menu.modals": "Modaux",
  "menu.tooltip": "Infobulles",
  "menu.popover": "Popovers",
  "menu.panels": "Panneaux",
  "menu.carousel": "Carrousels",
  "menu.columns": "Colonnes",
  "menu.typography": "Typographie",
  "menu.pagination": "Pagination",
  "menu.player": "Joueur",
  "menu.alerts": "Alertes",
  "menu.forms": "Formulaires",
  "menu.tables": "Tables",
  "menu.charts": "Graphiques",
  // Buttons Page
  "button.reactify": "Reactify Buttons",
  "button.light": "Button Light",
  "button.primary": "Button Primary",
  "button.secondary": "Secondary",
  "button.info": "Button Info",
  "button.danger": "Button Danger",
  "button.warning": "Reactify Warning",
  "button.dark": "Button Dark",
  "button.orange": "Buttons Orange",
  "button.turquoise": "Button Turquoise",
  "button.green": "Button Green",
  "button.yellow": "Button Yellow",
  "button.purple": "Button Purple",
  "button.aqua": "Button Aqua",
  "button.brown": "Reactify Brown",
  "button.light-green": "Light Green",
  "button.success": "Button Success",
  "button.outline": "Outline Buttons",
  "button.with-icons": "Button With Icons",
  "icon.button": "Icon Button",
  "button.sizes": "Buttons with Sizing",
  "button.large-button": "Large Button",
  "button.regular-button": "Regular Button",
  "button.small-button": "Small Button",
  "button.very-small-button": "Very Small Button",
  "button.disabled": "Disabled Button",
  "button.block-button": "Block Button",
  "button.social": "Social Buttons With Icons",
  "button.more-social": "More Social Buttons",
  "button.services": "Services",
  "button.content-sites": "Content Sites",
  "button.gaming-sites": "Gaming Sites",
  "button.misc-buttons": "Misc Buttons",
  "button.store-button": "Store Buttons",
  "button.rounded-buttons": "Rounded Buttons",
  "button.with-badges": "Buttons With Badges",
  "button.heading-badges": "Heading With Badges",
  "modal.modal-normal": "Normal Modal",
  "modal.modals-": "Different Modals",
  "modal.large-modal": "Large Modals",
  "modal.variation-modal": "Variation Modal",
  "modal.backdrop-status": "Choose Backdrop Status/Value",
  "modal.nested-modal": "Nested Modals",
  "modal.narrow-modal": "Narrow Modals",
  "modal.wide-modal": "Wide Modals",
  "tooltip.variation": "Tooltip Variations",
  "tooltip.in-the-link": "Tooltip in The Link",
  "tooltip.placements": "Tooltip With Different Placements",
  "tooltip.UncontrolledTooltip": "UncontrolledTooltip",
  "popover.examples": "Popover Example",
  "popover.placements": "Popover Placements",
  "popover.top": "Popover Top",
  "popover.bottom": "Popover Bottom",
  "popover.right": "Popover Right",
  "popover.left": "Popover Left",
  "carousel.wide": "Full Width Carousel",
  "carousel.team": "Team Carousel",
  "carousel.post": "Posts Carousel",
  "forms-inline": "Inline Form",
  "forms.username": "Username",
  "forms.username-required": "Username is Required",
  "forms.password": "Password",
  "forms.password-required": "Password is Required",
  "forms.login": "Login",
  "menu.forms-input": "Form Inputs",
  "menu.forms-inputs": "Form Inputs",
  "products.add-new": "Add New Item",

  // App UIs

  "menu.apexcharts": "ApexChart",
  "menu.sparkline": "Sparkline",
  "menu.chartjs": "ChartJS",
  "menu.extras": "Pages supplémentaires",
  "menu.login": "Connexion",
  "menu.register": "S'inscrire",
  "menu.forgot.password": "Mot de passe oublié",
  "menu.products.page": "Page des produits",
  "menu.products-page": "Page des produits",
  "products.add-new-items": "Ajouter un nouvel article",
  "product-name": "Nom de l'article",
  "product.category": "Type de poste",
  "product.description": "Description de l'article",
  "product.status": "Statut",
  "product.cancel": "Annuler",
  "product.submit": "Soumettre",
  "products.edit-item": "Modifier le produit",
  "products.delete-item": "Supprimer le produit",
  "products.delete-confirm-title": "Supprimer ce produit ?",
  "products.delete-confirm-body":
    "Cela retire le produit de la liste actuelle. La démo n'appelle pas de serveur.",
  "products.save-changes": "Enregistrer",
  "products.delete-confirm": "Supprimer",
  "team-message.quick-actions": "Actions rapides",
  "team-message.placeholder-call": "Appeler",
  "team-message.placeholder-video": "Vidéo",
  "error.go-home": "Aller à la page d'accueil",
  "menu.no-dropdown": "Sans Dropdown",
  "menu.menu": "Dropdown",
  "menu.carousels": "Carrousels",
  "menu.blank-page": "Page blanche",
  "menu.blankpage": "Page blanche",
  "menu.blank": "Blanche"
};

export default messages;
